import { getApiClient } from '@signalvote/api-client';
import { defineQuery, defineWrite, edit, requireSelectedCampaign } from '../../lib/data';

const api = getApiClient();

export interface VolunteerResourcesData {
  quickTips: string;
  script: string;
}

export type VolunteerResourceType = 'quickTips' | 'script';

const apiResourceType: Record<VolunteerResourceType, string> = { quickTips: 'QuickTips', script: 'Script' };

/** The quick tips and the volunteer script; a write naming a volunteer resource refreshes both. */
export const useVolunteerResources = defineQuery({
  key: () => ['volunteerResources'],
  reads: 'GET /api/VolunteerResources/{resourceType}',
  fetch: async (_: undefined, { campaignId }): Promise<VolunteerResourcesData> => {
    requireSelectedCampaign(campaignId);
    const [quickTips, script] = await Promise.all([
      api.volunteerResources.getResource(apiResourceType.quickTips),
      api.volunteerResources.getResource(apiResourceType.script),
    ]);
    return { quickTips: quickTips.content || '', script: script.content || '' };
  },
});

export const useUpdateVolunteerResource = defineWrite({
  send: ({ resourceType, content }: { resourceType: VolunteerResourceType; content: string }) =>
    api.volunteerResources.updateResource(apiResourceType[resourceType], { content }),
  land: (saved, { resourceType }) => [
    edit(useVolunteerResources, undefined, (shown) => ({ ...shown, [resourceType]: saved.content || '' })),
  ],
});
